import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const GoogleAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const success = params.get("success");
    const email = params.get("email");
    const username = params.get("username");
    const avatar = params.get("avatar");
    const id = params.get("id");
    const role = params.get("role");

    if (success === "true") {
      localStorage.setItem(
        "userInfo",
        JSON.stringify({ email, username, avatar, id, role })
      );
      toast.success("Đăng nhập thành công");
    } else {
      toast.error("Đăng nhập thất bại");
    }

    navigate("/home");
  }, [navigate]);

  return <div>Đang xử lý đăng nhập...</div>;
};

export default GoogleAuthCallback;
